import React, { useState, useEffect, useRef } from 'react';

export function MobileNumber(props) {
  const [disable, setDisable] = useState(true);
  const [value, setValue] = useState("");
  const [inputDisabled, setInputDisabled] = useState(false);
  const [buttonSubmitted, setButtonSubmitted] = useState(false); // New state for button color

  const inputRef = useRef(null); // Create a ref for the input element

  useEffect(() => {
    // Focus the input field when the component loads
    if (inputRef.current) {
      inputRef.current.focus();
    }
  }, []);

  const handleKeyDown = (e) => {
    // If "Enter" key is pressed, trigger the handleSubmit
    if (e.key === 'Enter' && !disable) {
      handleSubmit();
    }
  };

  const handleTextField = (e) => {
    const limit = 10;
    let inputValue = e.target.value.replace(/\D/g, ''); // Remove non-digit characters

    // If the first digit is not between 6 and 9, reset to an empty string
    if (inputValue && !/^[6-9]/.test(inputValue)) {
      inputValue = "";
    }

    const truncatedValue = inputValue.slice(0, limit); // Limit to 10 digits
    setValue(truncatedValue);

    // Enable the button only if the input has exactly 10 digits
    setDisable(truncatedValue.length !== 10);
  };

  const handleSubmit = () => {
    props.workflowDataHandler(value);
    setInputDisabled(true);
    setDisable(true);
    setButtonSubmitted(true);
  };

  return (
    <div style={styles.paperContainer}>
      <p style={styles.text} >Please enter your registered 10-digit mobile number.</p>
      <input
        placeholder="Enter here"
        value={value}
        ref={inputRef}
        onChange={handleTextField}
        style={styles.textField}
        disabled={inputDisabled}
        onKeyDown={handleKeyDown} // Listen for keydown event
        maxLength="10"
      />
      <button
          style={{
            ...styles.button,
            backgroundColor: buttonSubmitted ? 'grey' : 'rgba(12, 77, 162, 1)', // Conditional background color
          }}
        disabled={disable}
        onClick={handleSubmit}
      >
        Submit
      </button>
    </div>
  );
}

const styles = {
  paperContainer: {
    width: '83%',
    border: '8px solid rgba(244, 176, 53, 0.8)',
    padding: '12px 12px 8px 12px',
    textAlign: 'center',
    borderRadius: '25px',
    backgroundColor: 'rgba(245, 243, 243, 1)',
    marginLeft: '8px'
  },
  text: {
    color: '#0C4DA2',
    fontWeight: "bold"
    
  },
  textField: {
    border: "2px solid rgb(12, 77, 162)",
    borderRadius: "8px",
    marginTop: "0.5rem",
    backgroundColor: "white",
    textAlign: "center",
    padding: "12px 10px 10px 10px",
    width: "90%",
    height: "42px",
  },
  button: {
    backgroundColor: 'rgba(12, 77, 162, 1)',
    marginTop: '0.5rem',
    color: 'white',
    padding: '10px 20px',
    border: 'none',
    borderRadius: '5px',
    cursor: 'pointer',
    display: 'block', // Ensure the button is treated as a block element
    marginLeft: 'auto', // Center horizontally
    marginRight: 'auto',
  },
};
